import { styled } from '@/stitches.config';
import { Video } from './Video';
import { VideoControls } from './VideoControls';

interface VimeoPlayerProps {
  videoId?: string;
  aspectRatio?: number | 'native';
  autoplay?: boolean;
  controls?: boolean;
  loop?: boolean;
  muted?: boolean;
  display?: 'normal' | 'full';
  title?: string;
}

export function VimeoPlayer({
  videoId,
  aspectRatio = 'native',
  autoplay = false,
  controls = true,
  loop = false,
  muted = true,
  display = 'normal',
  title,
}: VimeoPlayerProps) {
  if (!videoId) {
    console.warn('Video is missing videoId');
    return null;
  }

  return (
    <Container display={display}>
      {title && <Title shouldIndent={display === 'full'}>{title}</Title>}

      <Video
        videoId={videoId}
        aspectRatio={aspectRatio}
        autoplay={autoplay}
        loop={loop}
        muted={muted}
      >
        {controls && <VideoControls autoplay={autoplay} />}
      </Video>
    </Container>
  );
}

const Container = styled('div', {
  variants: {
    display: {
      normal: {
        gridColumn: 'wide !important',
      },
      full: {
        gridColumn: 'full !important',
      },
    },
  },
  defaultVariants: {
    display: 'normal',
  },
});

const Title = styled('div', {
  fontWeight: '500',
  marginBottom: '$4',
  variants: {
    shouldIndent: {
      true: {
        marginLeft: '$4',
        '@bp3': {
          marginLeft: '$6',
        },
        '@bp4': {
          marginLeft: '$8',
        },
      },
    },
  },
});
